export const DISCORD_URL = import.meta.env.VITE_DISCORD_URL ?? "https://discord.gg/the-veil";
export const API_SECRET_TOKEN = import.meta.env.VITE_API_SECRET_TOKEN ?? "";
export const APP_HOST = import.meta.env.VITE_APP_HOST ?? "localhost:3000";
